<template>
  <div>
    <headerNotice routerName="提现管理"></headerNotice>
    <!-- 搜索栏 -->
    <div class="searchBox">
      <el-row :gutter="24">
        <!-- 搜索框 -->
        <el-col :span="5" :offset="0">
          <el-input placeholder="请输入客户名称" v-model="serachForm.userName">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <!-- 标签搜索 -->
        <el-col :span="4" :offset="0">
          <el-date-picker
            @change="durationChange"
            style="width:240px;"
            v-model="duration"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-col>
        <el-col :span="4" :offset="0">
          <el-select v-model="serachForm.status" @change="tagSearch" placeholder="提现状态">
            <el-option label="请选择提现状态" :value="0"></el-option>
            <el-option
              v-for="item in classifylist"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" :offset="0">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <!-- <el-col :span="2" :offset="2">
          <el-button type="primary" @click="add">
            <i class="el-icon-plus"></i> 新增
          </el-button>
        </el-col>-->
      </el-row>
    </div>
    <!-- 数据表格 -->
    <div class="dataTable" v-loading="loading">
      <!-- 多选操作 -->
      <div style="margin-bottom: 20px">
        <span class="notice" v-if="choosedItem.length">
          已经选择
          <i>{{choosedItem.length}}</i> 项
        </span>
        <el-button type="danger" @click="auditChoosed()">批量审核</el-button>
        <el-button type="danger" @click="rejectChoosed()">批量驳回</el-button>
        <el-button type="danger" @click="grantChoosed()">微信支付批量发放</el-button>
      </div>
      <div class="searchListContent">
        <el-table
          ref="searchListTable"
          :data="quotationlist"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="userName" label="客户名称"></el-table-column>
          <el-table-column align="center" prop="createTime" label="申请时间"></el-table-column>
          <el-table-column align="center" prop="money" label="提现金额"></el-table-column>
          <el-table-column align="center" prop="status" label="账号类型">
            <template slot-scope="scope">
              <span v-if="scope.row.status==5||1==1">微信零钱</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="openId" label="openid"></el-table-column>
          <el-table-column align="center" prop="userName" label="收款人"></el-table-column>
          <el-table-column align="center" prop="status" label="提现状态" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.status==5">待审核</span>
              <span v-if="scope.row.status==1">已审核</span>
              <span v-if="scope.row.status==2">已发放</span>
              <span v-if="scope.row.status==3">驳回</span>
              <span v-if="scope.row.status==4">异常</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="updateTime" label="发放时间"></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="240">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status==5"
                type="text"
                size="small"
                @click="onaudit(scope.row)"
              >审核</el-button>
              <el-button
                v-if="scope.row.status==5"
                type="text"
                size="small"
                @click="onreject(scope.row)"
              >驳回</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[25, 50, 75, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>

      <el-dialog title="驳回理由" class="searchDialog" :visible.sync="rejectDialog" width="50%">
        <el-input placeholder="请输入驳回理由" v-model="rejectRemark"></el-input>
        <el-button type="text" size="small" @click="rejectok">确认</el-button>
        <el-button type="text" size="small" @click="rejectreturn">取消</el-button>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
const map = { boolean: { 0: "否", 1: "是" } };
export default {
  data() {
    return {
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      totalCount: 0, //总数据条数
      currentPage: 1,

      quotationlist: [], //列表主数据

      serachForm: {
        maxResultCount: 25, //默认一页显示的个数,
        skipCount: 0,
        money: 0, //语录
        status: 0,
        startTime: null,
        endTime: null,
        userName: ""
      }, //查询条件
      classifylist: [
        { value: "5", lable: "待审核" },
        { value: "1", lable: "已审核" },
        { value: "2", lable: "已发放" },
        { value: "3", lable: "驳回" },
        { value: "4", lable: "异常" }
      ], //提现状态列表
      choosedItem: [],

      duration: [],
      rejectDialog: false, //驳回弹出
      rejectRemark: "",
      rejectwithdrawDepositID: []
    };
  },
  components: {
    headerNotice
  },

  mounted() {
    this.getDatas(this.serachForm);
  },
  methods: {
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/WithdrawDepositByUserAppsService/GetWithdrawDepositList",
        params: params,
        success(res) {
          self.quotationlist = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },

    //勾选单个表格
    handleSelectionChange(val) {
      this.choosedItem = val;
      console.log(this.choosedItem);
    },

    // 根据时间搜索
    durationChange(val) {
      if (!val) {
        val = [];
      }
      this.serachForm.startTime = val[0];
      this.serachForm.endTime = val[1];
    },

    //查询
    search() {
      this.serachForm.SkipCount = 0;
      let serachForm = this.serachForm;
      this.getDatas(serachForm);
    },

    //新增
    add() {
      this.$router.push({
        path: "/addQuotations?type=1" //新增操作
      });
    },
    //编辑
    onEdit(row) {
      this.$router.push({
        path: "/addQuotations?type=2&id=" + row.customizationID //编辑操作
      });
    },
    onDetail(row) {
      this.$router.push({
        path: "/addQuotations?type=0&id=" + row.customizationID //查看操作
      });
    },
    //单条审核
    onaudit(row) {
      let params = { withdrawDepositID: [row.withdrawDepositID] };
      this.audit(params);
    },
    //批量审核
    auditChoosed() {
      if (this.choosedItem.length == 0) {
        this.$message.error("没有勾选项");
        return;
      }
      debugger;
      let withdrawDepositID = [];
      for (let index = 0; index < this.choosedItem.length; index++) {
        const element = this.choosedItem[index];
        if (element.status != 5) {
          this.$message.error("不是待审核状态数据无法审核");
          return;
        }
        withdrawDepositID.push(element.withdrawDepositID);
      }
      let params = { withdrawDepositID: withdrawDepositID };
      //params = "?" + params.join("&");
      this.audit(params);
    },
    //审核
    audit(params) {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          self.$store.state.apiUrl +
          "/api/services/app/WithdrawDepositByUserAppsService/ToExamine",
        data: params,
        success(res) {
          self.$message({
            message: "审核成功",
            type: "success"
          });
          self.serachForm.MaxResultCount = self.maxResultCount;
          self.getDatas(self.serachForm);
          self.currentPage = 1;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //单条驳回
    onreject(row) {
      this.rejectDialog = true;
      this.rejectwithdrawDepositID = [row.withdrawDepositID];
      //let params = { withdrawDepositID: [row.withdrawDepositID] };
      //this.reject(params);
    },
    //批量驳回
    rejectChoosed() {
      if (this.choosedItem.length == 0) {
        this.$message.error("没有勾选项");
        return;
      }
      debugger;
      let withdrawDepositID = [];
      for (let index = 0; index < this.choosedItem.length; index++) {
        const element = this.choosedItem[index];
        if (element.status != 5) {
          this.$message.error("不是待审核状态数据无法驳回");
          return;
        }
        withdrawDepositID.push(element.withdrawDepositID);
      }
      this.rejectDialog = true;
      this.rejectwithdrawDepositID =withdrawDepositID;
      //let params = { withdrawDepositID: withdrawDepositID };
      //params = "?" + params.join("&");
      //this.reject(params);
    },
    rejectok(){
      let params = {
withdrawDepositID:this.rejectwithdrawDepositID,
rejectRemark:this.rejectRemark
      };
      this.reject(params);
    },

    rejectreturn(){
      this.rejectRemark = "";
      this.rejectDialog = false;
    },
    //驳回
    reject(params) {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          self.$store.state.apiUrl +
          "/api/services/app/WithdrawDepositByUserAppsService/Reject",
        data: params,
        success(res) {
          self.$message({
            message: "驳回成功",
            type: "success"
          });
          self.rejectDialog = false;
          self.serachForm.MaxResultCount = self.maxResultCount;
          self.getDatas(self.serachForm);
          self.currentPage = 1;
          self.loading = false;
          
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //批量发放
    grantChoosed() {
      if (this.choosedItem.length == 0) {
        this.$message.error("没有勾选项");
        return;
      }
      debugger;
      let withdrawDepositID = [];
      for (let index = 0; index < this.choosedItem.length; index++) {
        const element = this.choosedItem[index];
        if (element.status != 1) {
          this.$message.error("不是已审核状态数据无法发放");
          return;
        }
        withdrawDepositID.push(element.withdrawDepositID);
      }
      let params = { withdrawDepositID: withdrawDepositID };
      //params = "?" + params.join("&");
      this.grant(params);
    },
    //发放
    grant(params) {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          self.$store.state.apiUrl +
          "/api/services/app/WithdrawDepositByUserAppsService/CashWithdrawal",
        data: params,
        success(res) {
          self.$message({
            message: "发放成功",
            type: "success"
          });
          self.serachForm.MaxResultCount = self.maxResultCount;
          self.getDatas(self.serachForm);
          self.currentPage = 1;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
  padding: 20px;
}
// 数据表格
.dataTable {
  margin: 20px;
  padding-bottom: 0;
  .tableBox {
    border: 1px solid #c5c5c5;
  }
  .goodBaseInfo {
    display: flex;
    align-items: center;
    .txtInfo {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      .title {
        font-size: 12px;
        color: #333;
      }
      .itemCode {
        font-size: 10px;
        color: #999;
      }
      .tags {
        display: flex;
        align-items: center;
        span {
          height: 18px;
          line-height: 18px;
          font-style: normal;
          font-size: 10px;
          padding: 0px 8px;
          color: #fff;
          background: #999;
          border-radius: 4px;
          margin-right: 4px;
        }
        /deep/ .el-popover__reference {
          cursor: pointer;
          margin: 0;
          padding: 0;
        }
      }
    }
    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
  .notice {
    display: inline-block;
    margin-right: 20px;
    i {
      font-style: normal;
      color: #f63b3b;
    }
  }
}
//高级搜索Dialog框
.searchDialog {
  .sale {
    display: flex;
    align-items: center;
    span {
      display: block;
      width: 125px;
      text-align: right;
      box-sizing: border-box;
      padding-right: 12px;
    }
    input {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100px;
      height: 32px;
      outline: #409eff;
      appearance: normal;
    }
  }
  .searchDialogBtn {
    text-align: center;
  }
}
//批量设置标签dialog框
.setTagsDialog {
  .tagNotice {
    margin-bottom: 20px;
  }
  .tagsDialogBtn {
    text-align: right;
    margin-top: 20px;
  }
}

// 库存详情dialog框
</style>
<style lang="scss">
.goodsListCheckBox {
  display: flex;
  flex-direction: column;
  label {
    margin-left: 0 !important;
  }
}
</style>